/**
 * Comments Entry Point
 * Main entry file for the comments functionality
 * 
 * @package PocketOption
 */

import { initAuthentication } from '../components/CommentsAuth.js';
import initCommentsRating from '../components/CommentsRating.js';
import initCommentsSystem from '../comments-init.js';
import { initCommentReplies, initCommentsForm } from '../components/CommentsForm.js';
import { modalBase } from '../components/ModalBase.js';

/**
 * Initialize all comments functionality
 */
const initComments = async () => {
  // Initialize authentication
  const authResult =  await initAuthentication();

  // Check if we're on a page with comments
  const commentsArea = document.querySelector('.comments-area');
  if (!commentsArea) {
    return;
  }

  // Initialize the comments rating system
  initCommentsRating.init();

  // Initialize the comments form
  const form = initCommentsForm({
    placeholderSelector: '.po-comments-form__placeholder',
    labels: {
      submitButton: 'Submit',
      placeholder: 'Write your comment here...',
    },
    auth: authResult,
    onSuccess: (data) => {
      // Show success message
      // const successMessage = document.createElement('div');
      // successMessage.classList.add('po-comments-form__success');
      // successMessage.textContent = 'Your comment has been submitted and is awaiting moderation.';
      
      modalBase(
        "Your comment has been submitted. ",
        "Once approved, it will appear in the comment section below this article.", 
        "ok"
      )

      // Insert after form
      // const formContainer = document.querySelector('.po-comments-form');
      // if (formContainer) {
      //   formContainer.appendChild(successMessage);
        
      //   // Remove success message after 5 seconds
      //   setTimeout(() => {
      //     formContainer.removeChild(successMessage);
      //   }, 5000);
      // }
    },
    onError: (error) => {
      // Show error message
      const errorMessage = document.createElement('div');
      errorMessage.classList.add('po-comments-form__error');
      errorMessage.textContent = error.message || 'There was an error submitting your comment. Please try again.';
      
      // Insert after form
      const formContainer = document.querySelector('.po-comments-form');
      if (formContainer) {
        formContainer.appendChild(errorMessage);
        
        // Remove error message after 5 seconds
        setTimeout(() => {
          formContainer.removeChild(errorMessage);
        }, 5000);
      }
    },
  });

  // Initialize comment reply functionality
  initCommentReplies({
    auth: authResult
  });
};

// Initialize when DOM is ready
document.addEventListener(
  'DOMContentLoaded',
  function() {
    initComments();

  }
);
